import { get } from "lodash";
import { formatPatientNameFromTemplate } from "./formatPatientNameFromTemplate";
export function getPatientDisplayName(patient, isLC, workspaceConfig) {
  var _patient$name, _workspaceConfig$data, _workspaceConfig$data2;
  var legacyName = (_patient$name = patient === null || patient === void 0 ? void 0 : patient.name) !== null && _patient$name !== void 0 ? _patient$name : "";
  if (!isLC) {
    return legacyName;
  }
  var nameFormat = (_workspaceConfig$data = workspaceConfig === null || workspaceConfig === void 0 || (_workspaceConfig$data2 = workspaceConfig.data) === null || _workspaceConfig$data2 === void 0 || (_workspaceConfig$data2 = _workspaceConfig$data2.ui_settings) === null || _workspaceConfig$data2 === void 0 ? void 0 : _workspaceConfig$data2.name_format) !== null && _workspaceConfig$data !== void 0 ? _workspaceConfig$data : undefined;
  if (nameFormat) {
    return formatPatientNameFromTemplate(nameFormat, get(patient, ["additional", "patient_name"]));
  }
  var patientFirst = String(get(patient, ["additional", "patient_name", "first"], "") || "").trim();
  if (patientFirst) {
    var patientMiddle = String(get(patient, ["additional", "patient_name", "middle"], "") || "").trim();
    var patientLast = String(get(patient, ["additional", "patient_name", "last"], "") || "").trim();
    return [patientFirst, patientMiddle, patientLast].filter(Boolean).join(" ");
  }
  return legacyName;
}